
import { User } from "@/types";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from "@/components/ui/select";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { useIsMobile } from "@/hooks/use-mobile";

interface GolferDropdownProps {
  members: User[];
  selectedUserId: string;
  setSelectedUserId: (userId: string) => void;
}

export const GolferDropdown = ({
  members,
  selectedUserId,
  setSelectedUserId
}: GolferDropdownProps) => {
  const isMobile = useIsMobile();

  if (members.length <= 1) {
    return null;
  }

  return (
    <div className="space-y-2">
      <Label htmlFor="user-select" className={isMobile ? 'text-xs' : ''}>Golfer</Label>
      <Select
        value={selectedUserId}
        onValueChange={setSelectedUserId}
      >
        <SelectTrigger className="w-full">
          <SelectValue placeholder="Select golfer" />
        </SelectTrigger>
        <SelectContent>
          {members.map((member) => (
            <SelectItem key={member.id} value={member.id} className="cursor-pointer">
              <div className="flex items-center space-x-2">
                <Avatar className="h-5 w-5">
                  <AvatarImage src={member.imageUrl || undefined} alt={member.name} />
                  <AvatarFallback className="bg-forest text-white text-xs">
                    {member.name.charAt(0)}
                  </AvatarFallback>
                </Avatar>
                <span>{member.name}</span>
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
